/* @flow */

import type { $WidgetSettingsKey } from 'CoreTypes/WidgetSettingsKey';

type $WidgetSettingsKeys = {
  [key: string]: $WidgetSettingsKey
};

const WidgetSettingsKeys: $WidgetSettingsKeys = {
  SK_API_KEY: {
    skey: 'apiKey',
    label: 'API key',
    mandatory: true,
    paramURL: 'dswApiKey'
  },
  SK_PREVIEW_MODE_DLB: {
    skey: 'previewModeDLB',
    label: 'DLB preview mode (DLC team only)',
    mandatory: false,
    paramURL: 'dswPreviewModeDLB'
  },
  SK_PREVIEW_MODE_SBX: {
    skey: 'previewModeSBX',
    label: 'Sandbox preview mode (DLC team only)',
    mandatory: false,
    paramURL: 'dswPreviewModeSBX'
  },
  SK_ELEMENT: {
    skey: 'element',
    label: 'DOM-element ID',
    mandatory: true
  },
  SK_CONFIG_ID: {
    skey: 'configId',
    label: 'Configuration ID',
    mandatory: true,
    paramURL: 'dswConfigId'
  },
  SK_MARKET: {
    skey: 'market',
    label: 'Market',
    mandatory: true,
    paramURL: 'dswMarket'
  },
  SK_LANGUAGE: {
    skey: 'language',
    label: 'Language',
    mandatory: true,
    paramURL: 'dswLanguage'
  },
  SK_SEARCH_PROFILE_NAME: {
    skey: 'searchProfileName',
    label: 'Search profile',
    mandatory: true,
    paramURL: 'dswSearchProfileName'
  },
  SK_SELECT_DEALER_CALLBACK: {
    skey: 'selectDealerCallback',
    label: 'Select dealer callback function',
    mandatory: false
  },
  SK_HIDDEN_FIELDS: {
    skey: 'hiddenFields',
    label: 'Hidden fields',
    mandatory: false,
    paramURL: 'dswHiddenFields'
  },
  SK_WHITE_LIST: {
    skey: 'whiteList',
    label: 'White list',
    mandatory: false,
    paramURL: 'dswWhiteList'
  },
  SK_BLACK_LIST: {
    skey: 'blackList',
    label: 'Black list',
    mandatory: false,
    paramURL: 'dswBlackList'
  },
  SK_HEIGHT: {
    skey: 'height',
    label: 'Custom integration height',
    mandatory: false,
    paramURL: 'dswHeight'
  },
  SK_THEME: {
    skey: 'theme',
    label: 'Theme',
    mandatory: false,
    paramURL: 'dswTheme'
  }
};

export default WidgetSettingsKeys;
